import hasIn from 'lodash/hasIn';

export const hasProperty = <T>(object: T, path: string | keyof T): path is keyof T => hasIn(object, path);
